import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import VehicleCostGraph from "./Vehicle Dashboard/VehicleCostGraph";
import VehicleDistanceGraph from "./Vehicle Dashboard/VehicleDistanceGraph";

const Dashboard = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">Vehicle Management - Dashboard</h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            {/* Add VehicleCostGraph below the header */}
            {/* <VehicleCostGraph /> */}
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
